function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 60px;\n  overflow: hidden;\n  transition: all 0.3s ease-in 0s;\n  border-right: 1px solid ", ";\n  background-color: ", ";\n  z-index: 5;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  &:hover {\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 16px 10px 0px;\n    width: 300px;\n    overflow: auto;\n    .acc-inner-content {\n      padding-left: 40px;\n    }\n  }\n  .title,\n  .name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n    text-transform: capitalize;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MenuList from './MenuList';
import MenuHeader from './MenuHeader';
import { defaultTheme } from '../../../utils';
var MenuWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.border;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.background;
});

var Menu = function Menu(_ref3) {
  var name = _ref3.name,
      menuItems = _ref3.menuItems,
      menuIcon = _ref3.menuIcon,
      onClickHandler = _ref3.onClickHandler,
      rest = _objectWithoutPropertiesLoose(_ref3, ["name", "menuItems", "menuIcon", "onClickHandler"]);

  return /*#__PURE__*/React.createElement(MenuWrapper, rest, /*#__PURE__*/React.createElement(MenuHeader, {
    name: name,
    menuIcon: menuIcon
  }), /*#__PURE__*/React.createElement(MenuList, {
    menuItems: menuItems,
    onClickHandler: onClickHandler
  }));
};

Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    selectedIconName: PropTypes.string.isRequired,
    type: PropTypes.string,
    link: PropTypes.string,
    redirect: PropTypes.bool
  })),
  menuIcon: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func.isRequired
} : {};
Menu.defaultProps = {
  theme: defaultTheme,
  name: '',
  menuItems: []
};
export default Menu;